import template from './reporting.html';
import controller from './reporting.controller';
import './reporting.scss';

const reportingComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default reportingComponent;


// WEBPACK FOOTER //
// ./client/app/components/reporting/reporting.component.js